

// You can use it as state property
const state = () => ({
    notices: [],
    loading: false,
})

// You can use it as a state getter function (probably the best solution)
const getters = {
    errors(state) {
        return state.notices.filter(s => s.type === 'error')
    },
    notices(state) {
        return JSON.parse(JSON.stringify(state.notices))
    },
    isLoading(state) {
        return state.loading
    }
}

// Mutation for when you use it as state property
const mutations = {
    postNotice(state, payload) {
        state.notices.push(payload)
    },

    hideNotice(state, index) {
        state.notices[index].showing = false
    },

    setLoading(state, loading) {
        state.loading = loading
    }
}
const actions = {


    addSuccess({commit}, payload) {
        commit('postNotice', {color: 'light-green', text: payload, showing: true})
    },
    addInfo({commit}, payload) {
        commit('postNotice', {color: 'yellow', text: payload, showing: true})
    },
    addError({commit}, payload) {
        commit('postNotice', {color: 'red', text: payload, showing: true})
    },

    handleGraphQlError({dispatch}, payload) {
        let message = payload.message

        if(payload.graphQLErrors.length > 0){
            payload.graphQLErrors[0].message

            if(payload.graphQLErrors[0].debugMessage){
                message = payload.graphQLErrors[0].debugMessage
            }
        }

        dispatch('addError', message)
    },

    hide({commit}, index) {
        commit('hideNotice', index)
    },

    loading({commit}, loading) {
        commit('setLoading', loading)
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}